import React from 'react';
import { Section } from './Section';
export function TheProblem() {
  return <Section className="max-w-4xl" data-id="element-250">
      <div className="relative" data-id="element-251">
        <div className="absolute -top-12 -left-8 text-blood/10 font-serif text-[12rem] leading-none select-none pointer-events-none" data-id="element-252">
          "
        </div>

        <div className="relative z-10 space-y-8" data-id="element-253">
          <p className="text-2xl md:text-3xl font-serif leading-relaxed text-foreground" data-id="element-254">
            El problema no es que te falte inteligencia, es que te falta un mapa
            de las sombras. Te han enseñado que la empatía es tu mayor virtud,
            pero sin límites, tu empatía es la puerta de entrada para
            manipuladores, narcisistas y colegas trepadores.
          </p>

          <p className="text-xl md:text-2xl font-serif leading-relaxed text-foreground/80" data-id="element-255">
            Vives con el miedo constante al conflicto, permitiendo que otros
            dicten tu valor y decidan tu futuro. Cada vez que guardas silencio
            para "no crear problemas", estás perdiendo un pedazo de tu
            autoridad. Si no aprendes a ver las leyes ocultas que rigen el
            comportamiento humano, siempre serás el extra en la película de
            alguien más.
          </p>
        </div>
      </div>
    </Section>;
}